/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {refreshKey} from '../api'

export const useMutationRefreshKey = createReactQueryMutationHook('refreshKey', refreshKey)
